import { render, staticRenderFns } from "./AsiCardDetail.vue?vue&type=template&id=a2901ad8&scoped=true&"
import script from "./AsiCardDetail.vue?vue&type=script&lang=ts&"
export * from "./AsiCardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AsiCardDetail.vue?vue&type=style&index=0&id=a2901ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2901ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VDivider,VIcon,VList})
